import { Component, OnInit, OnChanges, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';

import { DialogRef, ModalComponent, CloseGuard } from 'ngx-modialog-11';
import { BSModalContext } from 'ngx-modialog-11/plugins/bootstrap';

export class PdfDownloadContext extends BSModalContext {
  constructor(
    public title: string,
    public description: string,
    public model: any,
    public callback: Function,
    public fonts: string[],
  ) {
    super();
  }
}

@Component({
  selector: 'app-pdf-download',
  templateUrl: './pdf-download.component.html',
  styleUrls: ['./pdf-download.component.scss'],
})
export class PdfDownloadComponent implements OnInit, CloseGuard, OnChanges, OnDestroy, AfterViewInit, ModalComponent<PdfDownloadContext> {
  context: PdfDownloadContext;
  wrongAnswer: boolean;

  constructor(
    public dialog: DialogRef<PdfDownloadContext>,
    public renderer: Renderer2,
  ) {
    this.context = this.dialog.context;
    this.wrongAnswer = true;
    this.dialog.setCloseGuard(this);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {}

  ngOnChanges() {}

  ngOnDestroy() {}

  onClose() {
    this.wrongAnswer = false;
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return this.wrongAnswer;
  }

  download(document) {
    if (!this.context.callback) {
      return;
    }

    this.context.callback(document);
  }
}
